import { BasicTrip } from 'tripPlanner/types/common'

export const getUniqueTripName = (
  original: string,
  trips: BasicTrip[],
  maxLength: number,
): string => {
  let num = 0
  let proposed = prepareProposedTripName(maxLength, undefined, original)

  const existingNames = new Set(trips.map((trip) => trip.name))
  while (existingNames.has(proposed)) {
    num++
    if (num > 1000) {
      // This shouldn't really be hit unless a user intentionally
      // tries to create a trip with the same name 50 times
      // This function previously was a recursive one and apparently was running out of stack size
      // it didn't require recursion at all... though it shouldn't have theoretically run out of stack size...
      // we'll still report if the error of it not getting to a valid name in a reasonable amount of attempts is genuinely occurring.
      // if you're seeing this in the future and this has never gone off again, you can remove this if statement.
      throw new Error(
        'Number of attempts to generate unique trip name exceeded 50.',
      )
    }
    const suffix = ` (${num})`
    proposed = prepareProposedTripName(maxLength, suffix, original)
  }

  return proposed.replace(/[\n\r]/g, ' ')
}

export const prepareProposedTripName = (
  maxLength: number,
  suffix?: string,
  original?: string,
) => {
  if (original) {
    const additionalLength = suffix?.length || 0
    const trimmed = original.substring(0, maxLength - additionalLength - 1)
    return trimmed + (suffix ?? '')
  } else {
    return 'New Trip'
  }
}
